import { HotkeyBadgeWrapper } from 'pages/Tagging/components/HotkeyBadge/HotkeyBadgeStyles';
import styled from 'styled-components';
import {
  background,
  brand,
  divider,
  highlightGradientBlueDark,
  highlightGradientBlueLight,
  hotkeyGrey,
  hotkeyGreyDisabled,
  white,
} from 'styles/Colors';
import { Tooltip } from '@mui/material';
import React from 'react';

export const OptionWrapper = styled.div`
  font-family: Lato;
  font-size: 16px;
  font-weight: bold;
  color: ${hotkeyGrey};
  border-bottom: 1px solid ${divider};
  padding: 7px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    background-color: ${background};
  }
  &:active {
    color: ${brand};
  }
  &.disabled {
    color: ${hotkeyGreyDisabled};
    ${HotkeyBadgeWrapper} {
      .text {
        color: ${hotkeyGreyDisabled};
      }
      .hotkey {
        color: ${hotkeyGreyDisabled};
      }
    }
    svg {
      path {
        fill: ${hotkeyGreyDisabled};
      }
    }

    ${HotkeyBadgeWrapper} {
      color: ${hotkeyGreyDisabled};
    }
  }
  &.selected {
    background-image: linear-gradient(273deg, ${highlightGradientBlueLight}, ${highlightGradientBlueDark});
    border-radius: 5px;
    color: ${white};
  }
  cursor: pointer;
  &:last-of-type {
    border-bottom: none;
  }
  svg {
    position: relative;
    width: 16px;
    height: 16px;
  }
  ${HotkeyBadgeWrapper} {
    margin-right: 8px;
  }
`;

export const DisplayName = styled.span`
  display: flex;
  align-items: center;
  gap: 7px;
`;
